import { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

interface Props {
  onScan: (code: string) => void;
  onClose: () => void;
}

export default function BarcodeScanner({ onScan, onClose }: Props) {
  const elemId = 'barcode-scanner-region';
  const scannerRef = useRef<Html5Qrcode | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const scanner = new Html5Qrcode(elemId);
    scannerRef.current = scanner;

    scanner.start(
      { facingMode: 'environment' },
      { fps: 10, qrbox: { width: 250, height: 250 } },
      (decodedText) => {
        onScan(decodedText);
        scanner.stop().catch(() => {});
      },
      () => {} // ignore decode errors per frame
    ).catch((e) => {
      setError(`Không mở được camera: ${e.message || e}`);
    });

    return () => {
      scanner.stop().catch(() => {});
    };
  }, []);

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 10000, background: 'rgba(0,0,0,0.95)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ position: 'absolute', top: 16, right: 16, zIndex: 10001 }}>
        <button onClick={onClose} className="btn btn-secondary">
          <span className="material-symbols-outlined">close</span>
          Đóng
        </button>
      </div>
      {error ? (
        <div style={{ color: '#fff', padding: 24 }}>{error}</div>
      ) : (
        <div id={elemId} style={{ width: '100%', maxWidth: 480, background: '#000' }} />
      )}
    </div>
  );
}
